import React, { useEffect, useState } from "react";
import { apiGet } from "../../services/api";
import "./DayCashFlow.css";

interface DaySummaryData {
  clinical_revenue?: { billed?: number; collected?: number };
  supplier_payments?: number;
  pharmacy_bills: any[];
  totals?: {
    billed_total: number;
    collected_total: number;
    expenses_total: number;
    other_income_total: number;
    net_cash_in_hand: number;
  };
  lab_payments?: number;
  consultant_payments?: number;
}

export default function DayCashFlow() {
  const today = new Date().toISOString().slice(0, 10);

  const [date, setDate] = useState(today);
  const [data, setData] = useState<DaySummaryData | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadSummary();
  }, [date]);

  const loadSummary = async () => {
    setLoading(true);
    try {
      const res = await apiGet(`/api/manager/day-summary?date=${date}`);
      setData(res as DaySummaryData);
    } catch (e) {
      console.error("Day cash flow error", e);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  const revenue = data?.clinical_revenue?.collected || 0;
  const expenditure = data?.totals?.expenses_total ?? ((data?.supplier_payments || 0) + (data?.lab_payments || 0) + (data?.consultant_payments || 0));
  const netCollection = data?.totals?.net_cash_in_hand ?? (revenue - expenditure);

  return (
    <div className="card day-cash-card">
      <div className="dc-header">
        <h3>💰 Daily Financials</h3>

        <input
          type="date"
          value={date}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDate(e.target.value)}
        />
      </div>

      {loading ? (
        <p className="muted">Loading summary…</p>
      ) : !data ? (
        <p className="muted">No data available</p>
      ) : (
        <div className="dc-grid">
          <div className="dc-box positive">
            <label>💰 Revenue</label>
            <div className="amount">
              ₹{revenue.toLocaleString()}
            </div>
            <span className="dc-sublabel">Clinic bill collections</span>
          </div>

          <div className="dc-box negative">
            <label>📤 Total Expenditure</label>
            <div className="amount">
              -₹{expenditure.toLocaleString("en-IN")}
            </div>
            <span className="dc-sublabel">All expenses</span>
          </div>

          <div className={`dc-box net ${(data.totals?.net_cash_in_hand || 0) >= 0 ? "positive" : "negative"}`}>
            <label>📈 Net Collection</label>
            <div className="amount">
              ₹{netCollection.toLocaleString()}
            </div>
            <span className="dc-sublabel">Revenue - Expenditure</span>
          </div>
        </div>
      )}
    </div>
  );
}
